/* eslint-disable react/jsx-key */
import React from "react";
import { Button, Card } from "antd";
import { Map } from "immutable";
import PropTypes from "prop-types";

const gridStyle = {
    width: "33%",
    textAlign: "center",
    alignItems: "center"
};

class TilesView extends React.Component {

    truncateString(inputString, maxLength) {
        if (inputString.length <= maxLength) {
            return inputString;
        } else {
            const firstPart = inputString.slice(0, 10);
            const lastPart = inputString.slice(-10);
            return `${firstPart}...${lastPart}`;
        }
    }

    render() {
        const { title, images } = this.props;
        return (
            <Card
                className={"padless-card no-shadow"}
                title={!images?.proof_doc? title : null}
                style={!images?.proof_doc?{
                    minHeight: "300px",
                    width: "100%",
                } : {
                    width: "100%",
                }
                }
                size={"small"}
                extra={this.props.extra}
            >
                {images &&
                    new Map(images)
                        .map(_ => {
                            if(_?.length || _.file?.length){
                                return (
                                    _ && 
                                    _.file && _.file.map(__ => {
                                        if(_.key === "proof_doc"){
                                            return(
                                                <div className="d-flex">
                                                    <p>{this.truncateString(__, 20)}</p>
                                                    <Button style={{border:"none", height:"0rem"}} onClick={() => this.props.onChange(_, __)}>X</Button>
                                                </div>
                                            );
                                        }
                                        return(
                                            <Card.Grid style={gridStyle}>
                                                <img
                                                    src={__}
                                                    style={{
                                                        minHeight: "300px",
                                                        maxHeight: "500px",
                                                        maxWidth: "300px",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                                <Button onClick={() => this.props.onChange(_, __)}>Remove</Button>
                                            </Card.Grid>
                                        );
                                    })
                                );
                            }
                            return (null);
                        })
                        .toList()
                        .toArray()}
            </Card>
        );
    }
}

TilesView.propTypes = {
    title: PropTypes.string,
    images: PropTypes.array,
    onChange: PropTypes.func,
    onFileUploadComplete: PropTypes.func,
    extra: PropTypes.array
};

export default TilesView;
